var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"absolute max-h-full max-w-full object-contain overflow-hidden rounded-lg shadow-2xl select-none bg-gray-800",attrs:{"src":_vm.src},on:{"load":_vm.onImageLoaded}})}
var staticRenderFns = []

export { render, staticRenderFns }